import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.scss';

const Spinner = ({ marginY }: { marginY?: 'small' | 'medium' | 'large' }) => {
  return (
    <div
      className={clsx(`react-loader`, {
        [styles[`${marginY}MarginY`]]: marginY,
      })}
    ></div>
  );
};

export default Spinner;
